import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { AdminNoteService } from '@/modules/common/note/services/admin-note.service'
import { NoteCollectionModel } from '@/modules/common/note/models/note-collection.model'
import { Data } from '@/modules/shared/models/data'
import { NoteIndexRequestModel } from '@/modules/common/note/models/note-request.model'

@vservice()
export class AdminNoteGetNotesUseCase {
  public remoteData = RemoteData
    .notAsked<Data<NoteCollectionModel>>()

  constructor(
    private readonly service: AdminNoteService
  ) {
  }

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get data() {
    return this.remoteData.fold(
      () => null,
      value => value?.data || null,
      value => value.data,
      (error, value) => value?.data || null
    )
  }

  execute(modelId: number, modelType: string): RemoteData<Data<NoteCollectionModel>> {
    let getIndexRequest: NoteIndexRequestModel = {
      model_id: modelId,
      model_type: modelType
    }
    return this.remoteData.fromPromise(
      this.service.getNotes(getIndexRequest))
  }

}
